





























import { Component } from 'vue-property-decorator';
import { RolesModule } from '@/store/Settings/RolesModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import RoleDetails from '@/components/Settings/Roles/RoleDetails.vue';

@Component({ name: 'Role', components: { Alert, RoleDetails }, metaInfo: { title: 'Roles' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await RolesModule.getRole(this.$route.params.id);
    }

    get role() {
        return RolesModule.role;
    }

    get loading() {
        return RolesModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
